import { render, staticRenderFns } from "./quote-list-employer-detail.vue?vue&type=template&id=007b6753"
import script from "./quote-list-employer-detail.vue?vue&type=script&lang=js"
export * from "./quote-list-employer-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports